import { useState } from "react";

export function Input({
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  error,
  hint,
  right,
  onKeyDown,
  disabled = false,
}) {
  const [show, setShow] = useState(false);

  return (
    <div style={{ marginBottom: 18 }}>
      {label && (
        <label
          style={{
            display: "block",
            fontSize: 12,
            fontWeight: 600,
            color: "#94a3b8",
            marginBottom: 6,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
          }}
        >
          {label}
        </label>
      )}
      <div style={{ position: "relative" }}>
        <input
          type={type === "password" && show ? "text" : type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          disabled={disabled}
          style={{
            width: "100%",
            background: "rgba(255,255,255,0.04)",
            border: `1.5px solid ${error ? "#ef4444" : "rgba(255,255,255,0.12)"}`,
            borderRadius: 10,
            padding: "12px 14px",
            color: "#e2e8f0",
            fontSize: 14,
            outline: "none",
            boxSizing: "border-box",
            fontFamily: "inherit",
            paddingRight: type === "password" ? 42 : 14,
            opacity: disabled ? 0.72 : 1,
          }}
        />
        {type === "password" && (
          <button
            type="button"
            onClick={() => setShow((s) => !s)}
            style={{
              position: "absolute",
              right: 12,
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#94a3b8",
              fontSize: 14,
              padding: 0,
            }}
            disabled={disabled}
          >
            {show ? "🙈" : "👁️"}
          </button>
        )}
        {right && (
          <div
            style={{
              position: "absolute",
              right: 12,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            {right}
          </div>
        )}
      </div>
      {error && (
        <div style={{ fontSize: 12, color: "#ef4444", marginTop: 4 }}>{error}</div>
      )}
      {hint && !error && (
        <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>{hint}</div>
      )}
    </div>
  );
}
